// extracted by mini-css-extract-plugin
export default {"custom-icon":"InvoiceWarningIcon_custom-icon__kwG0J"};